{
  "fr": {
    "login": {
      "loginPupil": {
        "activeSession": {
          "confirm": "Se connecter",
          "text": "Vous êtes actuellement connecté·e en tant qu'enseignant·e. Pour utiliser le lien d'accès en tant qu'élève, vous serez d'abord déconnecté·e.",
          "title": "Se déconnecter et se connecter en tant qu'élève ?"
        },
        "appHandoff": {
          "continueInBrowser": "Continuer dans le navigateur",
          "openApp": "Ouvrir dans l'application",
          "subtitle": "Ouvrir dans l'application fobizz ?",
          "text": "Si vous avez l'application fobizz sur cet appareil, votre salle de classe s'ouvrira directement. Sinon, vous pouvez continuer ici dans le navigateur."
        },
        "error": "Ce code n'est malheureusement pas valide. As-tu peut-être fait une erreur de frappe ?",
        "instruction": "Tu recevras ton code d'accès de ta part de ton enseignant·e.",
        "logIn": "Se connecter",
        "subtitle": "Entrez votre code à 6 chiffres ici",
        "title": "Se connecter en tant qu'élève"
      },
      "loginTemporaryPupil": {
        "classFull": "Cette salle de classe est malheureusement déjà pleine. Veuillez contacter votre enseignant·e.",
        "error": "Ce lien n'est malheureusement plus valide.",
        "title": "Veuillez patienter, vous serez connecté·e sous peu..."
      }
    }
  }
}
